module.exports = __webpack_public_path__ + "static/media/bg_img1.8df65cd4.png";